import axios from "axios";
import { LiveAvatarSession } from "@heygen/liveavatar-web-sdk";
import { USER_BASE_URL } from "../API";

export const fetchLiveAvatarToken = async (headers) => {
    try {
        const { data } = await axios.post(
            `${USER_BASE_URL}/create-session`, {},
            { headers: { ...headers, "Content-Type": "application/json" } }
        );
        return { token: data.token };
    }
    catch (error) { console.log(error.message || "Failed to create LiveAvatar session"); }
};
export const startLiveAvatarSession = async (token) => {
    try {
        const session = new LiveAvatarSession(token, { voiceChat: true });
        await session.start();
        return session;
    }
    catch (error) { console.log(error.message || "Failed to start LiveAvatar session"); return null }
};
export const speakLiveAvatar = (session, text) => {
    if (!session || !text) return;
    try { session.repeat(text) }
    catch (err) { console.error("LiveAvatar speak error:", err); }
};
export const stopLiveAvatarSession = async (session) => {
    if (session) {
        try { await session.stop(); }
        catch (err) { console.error("LiveAvatar stop error:", err); }
    }
};
